/**
* Logo Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Logo Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';

( function( app ) {
  const COMPONENT = {

    className: 'logo-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.logo-slider__splide' ).each( function( key, component ) {
        new Splide( component, {
          type: 'loop',
          gap: '80px',
          perPage: 1,
          pagination: false,
          mediaQuery: 'min',
          breakpoints: {
            1028: {
              fixedWidth: '196px',
            },
          },
        } ).mount( {} );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'logo-slider', COMPONENT );
} )( app );
